import { Cookies } from "react-cookie";
import { fetch } from "~/utils/fetch.jsx";
import Angie from "./angie.jsx";

const cookie = new Cookies();

const getCsrfValidatorToken = () => {
  return cookie.get(window.csrfValidatorName);
};

const prepareRequestSettings = (request_type, prefetch_next = false) => {
  let request_token = getCsrfValidatorToken();
  let headers = {};

  // header for all requests
  headers[`Accept`] = `application/json, text/plain, * / *`;

  // Authorization token if authorized
  if (request_token) headers[`X-Angie-CsrfValidator`] = request_token;

  if (request_type === `GET`) {
    // GET requests
    headers[`Cache-Control`] = `public, max-age=0`;
    headers[`Pragma`] = `public`;
  } else if (request_type === `POST`) {
    // POST requests
    headers[`Content-Type`] = `application/json`;
  } else if (request_type === `PUT`) {
    // PUT requests
    headers[`Content-Type`] = `application/json`;
  }

  if (prefetch_next) {
    headers[`X-Angie-Prefetch`] = true;
    prefetch_next = false;
  }

  return { headers };
};

const upload = (file, callback) => (xml_http) => {
  return fetch({
    url: `${Angie.api_url}/upload-files`,
  }).then(
    (response) =>
      new Promise((resolve, reject) => {
        const progressCallback = (event) => {
          let total = event.total || event.totalSize;
          if (total) {
            let done = event.loaded || event.position;
            let progress = parseInt(Math.floor((done / total) * 1000) / 10);

            if (typeof callback === `function`) {
              callback(progress);
            }
          }
        };
        const onReadyStateChange = (event) => {
          const { target } = event;
          if (target.readyState !== 4) return true;
          if (target.status !== 200 && target.status !== 304) {
            reject(new Error(target.responseText));
          } else {
            try {
              let response = JSON.parse(target.responseText);
              if (Array.isArray(response) && response.length) {
                resolve(response[0]);
              } else {
                resolve(response);
              }
            } catch (error) {
              reject(error);
            }
          }
        };

        if (xml_http.upload) {
          xml_http.upload.onprogress = progressCallback;
        } else {
          xml_http.addEventListener(`progress`, progressCallback, false);
        }

        xml_http.onreadystatechange = onReadyStateChange;

        let intent = response.intent;
        let pingbackUrl = response.pingback_url;
        let form_data = new FormData();

        xml_http.open(`post`, response.upload_url, true);

        if (intent === null) {
          let headers = prepareRequestSettings(`POST`).headers;
          let csrf_token = headers[`X-Angie-CsrfValidator`];
          form_data.append(`file`, file);
          xml_http.setRequestHeader(`X-Angie-CsrfValidator`, csrf_token);
        } else {
          form_data.append(`files[]`, file);
          form_data.append(`intent`, intent);
          form_data.append(`pingbackUrl`, pingbackUrl);
          xml_http.setRequestHeader(`Accept`, `application/json`);
        }

        xml_http.send(form_data);
      })
  );
};

export default upload;
